import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";

import * as Constants from "../../../../constants/Constants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";
import {
  checkOnBoardingStatus,
  // checkMandatoryDocStatus,
} from "../../../../utils/utils";
// import { httpGetMandatoryDocumentStatus } from "../../../../service/httpClient";
import "./CommonActionsModal.css";
import { useSelector } from "react-redux";

const noteCategoryOptions = [
  {
    optionValue: "Agreement",
    optionName: "Agreement",
  },
  {
    optionValue: "Shipping Information",
    optionName: "Shipping Information",
  },
  {
    optionValue: "DUNS",
    optionName: "DUNS",
  },
  {
    optionValue: "Test UPC's",
    optionName: "Test UPC's",
  },
  {
    optionValue: "Other",
    optionName: "Other",
  },
];

const moreOptionsForMPIL = [
  {
    optionValue: "Tax verification data",
    optionName: "Tax verification data",
  },
  {
    optionValue: "DVN setup data",
    optionName: "DVN setup data",
  }
]

const CommonActionsModal = ({
  show,
  closeCommonActionsModal,
  actionType,
  handleChange,
  comments,
  onClickHandler,
  actionBtnDisabled,
  actionError,
  onboardingStatus,
  note,
  noteCategory,
  dataRequestType,
  dataRequestTypeComment,
  dataRequestTypeErr,
  noteError,
  handleValidate,
  vendorStatus,
  inactiveCategory,
  vendorProfileDetails,
  vendorDeleteOption,
  handleValidateDataReqType
}) => {
  const [dvnSetupStatus, setDVNSetupStatus] = useState("");
  const [isVendorInActive, setIsVendorInActive] = useState(false);

  const [
    eligibleForSubmitToMerchOps,
    // setEligibleForSubmitToMerchOps,
  ] = useState(false);
  const [isFormDataLoaded, setIsFormDataLoaded] = useState(false);
  const [hasDVNAudit, setHasDVNAudit] = useState(false);

  const getVendorConPlatformName = (value) => {
    const platformNames = {
      chub: "Commerce Hub",
      directEdi: "Direct EDI",
      directEdiRDS: "Direct EDI RDS",
      mcymirakl: "Macys-Mirakl",
      blmmirakl: "Bloomies-Mirakl",
    };
    return platformNames[value];
  };
  const store = useSelector(({ service }) => ({
    merchandiseType: service.vendorProfile?.vendorDetail?.merchandiseType || "",
    hierarchyDetails:
      service.vendorProfile?.vendorDetail?.hierarchyDetails || [],
    profileTypeDetails: service.vendorProfile?.profileTypeDetails,
    profileTypeAndConnection:
      service.vendorProfile?.vendorDetail?.merchandiseType &&
      service.vendorProfile?.vendorDetail?.vendorConnectionPlatform
        ? `(${
            service.vendorProfile?.vendorDetail?.merchandiseType
          }/${getVendorConPlatformName(
            service.vendorProfile?.vendorDetail?.vendorConnectionPlatform
          )})`
        : "",
  }));

  useEffect(() => {
    let status = "";
    let inActiveStatus = false; // Hold ---> Inactive

    if (vendorStatus.length > 0) {
      const setupDvn = vendorStatus.find(
        (item) => item.statusName === Constants.DVN_SET_UP_ID
      );
      if (setupDvn && vendorStatus) {
        status = setupDvn.vendorStatus.lastStatusUpdatedValue || "";
      }

      const vendorInActive = vendorStatus.find(
        (item) =>
          item.statusName === Constants.HOLD_ID &&
          item.vendorStatus?.statusId === 18
      );
      if (vendorInActive && vendorStatus) {
        inActiveStatus =
          vendorInActive.vendorStatus.lastStatusUpdatedValue ===
            Constants.APPROVED && vendorInActive.vendorStatus.statusCompleted;
      }
    }
    setDVNSetupStatus(status);
    setIsVendorInActive(inActiveStatus);

    // If we have to implement SubmitToMerchOps in action button then we just have to uncomment below line and do some state adjustment.
    // I kept below code as this was the initial requirement SVH-2078 which was changed later.
    // Hence keeping this code for future use, it will not impact current process.

    //Below has to comment in
    //checkIfEligibleForSubmitToMerchOps();
    //Below has to comment out
    setIsFormDataLoaded(true);

    return () => {
      setIsFormDataLoaded(false);
    };
  }, [vendorStatus]);

  useEffect(() => {
    let dvnAudit = false;
    store.hierarchyDetails.forEach((item) => {
      if (item.needDvnAudit && item.vendorNumber !== "0") {
        dvnAudit = true;
      }
    });
    setHasDVNAudit(dvnAudit);
  }, [store.hierarchyDetails]);

  const handleClose = () => closeCommonActionsModal();

  const getonboardingStatus = () =>
    onboardingStatus !== "" &&
    checkOnBoardingStatus(onboardingStatus, [
      Constants.DOCUMENT_SUBMITTED,
      Constants.DBM_APPROVED,
      Constants.ACCOUNTS_PAYABLE_APPROVED,
      Constants.IN_PROCESS,
      Constants.ON_HOLD,
      Constants.OB_COMPLETE,
    ]);

  const getActiveWindowInactiveStatus = () =>
    onboardingStatus !== "" &&
    checkOnBoardingStatus(onboardingStatus, [
      Constants.VENDOR_REGISTRATION,
      Constants.VENDOR_SUBMISSION,
      Constants.MERCHANT_APPROVED,
      Constants.DOCUMENT_SUBMITTED,
      Constants.DBM_APPROVED,
      Constants.ACCOUNTS_PAYABLE_APPROVED,
      Constants.IN_PROCESS,
      Constants.OB_COMPLETE,
      Constants.LIVE,
    ]);

  const getIntegrationHoldInactiveStatus = () =>
    onboardingStatus !== "" &&
    checkOnBoardingStatus(onboardingStatus, [
      Constants.ACCOUNTS_PAYABLE_APPROVED,
      Constants.IN_PROCESS,
      Constants.OB_COMPLETE,
      Constants.LIVE,
    ]);
  const getIntegrationUnresponsiveInactiveStatus = () =>
    onboardingStatus !== "" &&
    checkOnBoardingStatus(onboardingStatus, [
      Constants.VENDOR_REGISTRATION,
      Constants.VENDOR_SUBMISSION,
      Constants.MERCHANT_APPROVED,
      Constants.DOCUMENT_SUBMITTED,
      Constants.ACCOUNTS_PAYABLE_APPROVED,
      Constants.IN_PROCESS,
      Constants.OB_COMPLETE,
      Constants.LIVE,
    ]);

  const getPlaceHoder = () => {
    switch (actionType) {
      case Constants.ACTION_OPTIONS_REQUEST_VENDOR:
        return Constants.ACTION_REQUEST_VENDOR_MESSAGE_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_REQUEST_MERCHANT:
        return Constants.ACTION_REQUEST_MERCHANT_MESSAGE_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT:
        return Constants.ACTION_RETURN_TO_MERCHANT_MESSAGE_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES:
        return Constants.ACTION_DVN_AUDIT_NOTES_MESSAGE_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR:
      case Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS:
        return Constants.ACTION_REQUEST_INACTIVE_STATUS_VENDOR_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN:
        return Constants.ACTION_REQUEST_CONSIGNMENT_ADMIN_MESSAGE_PLACEHOLDER;
      case Constants.ACTION_OPTIONS_DELETE_VENDOR:
        return Constants.ACTION_REQUEST_DELETE_VENDOR_MESSAGE_PLACEHOLDER;
      case Constants.MP_REQUEST_MORE_DATA_ID:
        return Constants.MP_REQUEST_MORE_DATA_LABEL;
      default:
        return "";
    }
  };

  const rolePermissionForRequestMoreDetailsFromVendor = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_REQUESTMOREDETAILS_VENDOR
  );

  const rolePermissionForRequestMoreDetailsFromMerchant = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_REQUESTMOREDETAILS_MERCHANT
  );

  const rolePermissionForReturnToMerchant = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_RETURNTOMERCHANT
  );

  const rolePermissionForDVNAuditNotes = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_DVNAUDITNOTES
  );

  const rolePermissionForInactiveStatus = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_INACTIVE_STATUS
  );

  const rolePermissionForInactiveStatusIntegrationHold = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_INTEGRATION_HOLD
  );
  const rolePermissionForTerminateStatus = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_TERMINATE
  );

  const rolePermissionForInactiveStatusIntegrationUnresponsive = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_INTEGRATION_UNRESPONSIVE
  );

  const rolePermissionForRequestMoreDetailsFromConsignmentAdmin = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_REQUESTMOREDETAILS_CONSIGNMENT_ADMIN
  );

  const rolePermissionForDeleteVendor = getUserRolePermission(
    rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
    rolePermConsts.VMP_DELETEVENDOR
  );

  const inactiveStatusHoldOptions = () => {
    let statusCategory = [];
    let statusobj = {};

    if (
      getIntegrationHoldInactiveStatus() &&
      rolePermissionForInactiveStatusIntegrationHold === rolePermConsts.EDIT
    ) {
      statusobj = {
        optionValue: "integhold",
        optionName: "Integration Hold",
      };
      statusCategory.push(statusobj);
    }

    if (
      getIntegrationUnresponsiveInactiveStatus() &&
      rolePermissionForInactiveStatusIntegrationUnresponsive ===
        rolePermConsts.EDIT
    ) {
      statusobj = {
        optionValue: "unresponsive",
        optionName: "Unresponsive",
      };

      statusCategory.push(statusobj);
    }

    if (
      getIntegrationUnresponsiveInactiveStatus() &&
      rolePermissionForTerminateStatus === rolePermConsts.EDIT
    ) {
      statusobj = {
        optionValue: "terminate",
        optionName: "Terminated",
      };
      statusCategory.push(statusobj);
    }

    return statusCategory;
  };

  const isPrimayVendorAndHasNoSecondary = () => {
    if (
      store?.profileTypeDetails?.length > 1 &&
      vendorProfileDetails?.isPrimaryVendor
    ) {
      return false;
    }
    return true;
  };
  // const checkIfEligibleForSubmitToMerchOps = () => {
  //   const vendorProfileId = localStorage.getItem("vid");
  //   if (vendorProfileId) {
  //     httpGetMandatoryDocumentStatus(vendorProfileId)
  //       .then((res) => {
  //         if (res.data) {
  //           /**
  //            * This function is not in use. However, I am adding this check
  //            * so that in future if this is used, it will be in sync with
  //            * rest of the application.
  //            */
  //           setEligibleForSubmitToMerchOps(
  //             checkMandatoryDocStatus(onboardingStatus, res.data)
  //           );
  //         }

  //         setIsFormDataLoaded(true);
  //       })
  //       .catch((err) => {
  //         setEligibleForSubmitToMerchOps(false);
  //         setIsFormDataLoaded(true);
  //       });
  //   } else {
  //     setEligibleForSubmitToMerchOps(false);
  //     setIsFormDataLoaded(true);
  //   }
  // };

  return (
    <>
      <Modal
        contentClassName="commonActionsModal"
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isFormDataLoaded ? Constants.BUTTON_ACTIONS : "Please wait ..."}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="commonActionsModalBody">
          {actionError && (
            <Row className="py-0">
              <Col className="px-4">
                <p className="actionErrorMsg">{actionError}</p>
              </Col>
            </Row>
          )}
          {isFormDataLoaded && (
            <div className="vendorOnboarding_action_container">
              <div className="vendorOnboarding_action_selectionArea">
                {rolePermissionForRequestMoreDetailsFromVendor ===
                  rolePermConsts.EDIT && (
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id={Constants.ACTION_OPTIONS_REQUEST_VENDOR}
                      value={Constants.ACTION_OPTIONS_REQUEST_VENDOR}
                      label={Constants.ACTION_OPTIONS_REQUEST_VENDOR_LABEL}
                      onChange={handleChange}
                      checked={
                        actionType === Constants.ACTION_OPTIONS_REQUEST_VENDOR
                      }
                      disabled={
                        (onboardingStatus &&
                          onboardingStatus.toLowerCase() ===
                            Constants.LIVE.toLowerCase()) ||
                        dvnSetupStatus === Constants.DVN_SETUP_STATUS_PENDING
                      }
                    />
                  </Form.Group>
                )}
                {rolePermissionForRequestMoreDetailsFromMerchant ===
                  rolePermConsts.EDIT && (
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id={Constants.ACTION_OPTIONS_REQUEST_MERCHANT}
                      value={Constants.ACTION_OPTIONS_REQUEST_MERCHANT}
                      label={Constants.ACTION_OPTIONS_REQUEST_MERCHANT_LABEL}
                      onChange={handleChange}
                      checked={
                        actionType === Constants.ACTION_OPTIONS_REQUEST_MERCHANT
                      }
                      disabled={
                        dvnSetupStatus === Constants.DVN_SETUP_STATUS_PENDING
                      }
                    />
                  </Form.Group>
                )}
                {rolePermissionForRequestMoreDetailsFromConsignmentAdmin ===
                  rolePermConsts.EDIT &&
                  vendorProfileDetails?.merchandiseType ===
                    Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT && (
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN}
                        value={
                          Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN
                        }
                        label={
                          Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN_LABEL
                        }
                        onChange={handleChange}
                        checked={
                          actionType ===
                          Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN
                        }
                        disabled={
                          onboardingStatus !== "" &&
                          !checkOnBoardingStatus(onboardingStatus, [
                            Constants.DBM_APPROVED,
                          ])
                        }
                      />
                    </Form.Group>
                  )}
                {rolePermissionForReturnToMerchant === rolePermConsts.EDIT &&
                  store.merchandiseType !==
                    Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT}
                        value={Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT}
                        label={
                          Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT_LABEL
                        }
                        onChange={handleChange}
                        checked={
                          actionType ===
                          Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT
                        }
                        disabled={!getonboardingStatus()}
                      />
                    </Form.Group>
                  )}

                {eligibleForSubmitToMerchOps && (
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id={Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT}
                      value={Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT}
                      label={Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT_LABEL}
                      onChange={handleChange}
                      checked={
                        actionType ===
                        Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT
                      }
                    />
                  </Form.Group>
                )}

                {hasDVNAudit &&
                  rolePermissionForDVNAuditNotes === rolePermConsts.EDIT && (
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES}
                        value={Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES}
                        label={Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES_LABEL}
                        onChange={handleChange}
                        checked={
                          actionType ===
                          Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES
                        }
                      />
                    </Form.Group>
                  )}
                {rolePermissionForInactiveStatus === rolePermConsts.EDIT &&
                  getActiveWindowInactiveStatus() && (
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR}
                        value={Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR}
                        label={
                          Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR_LABEL
                        }
                        onChange={handleChange}
                        checked={
                          actionType ===
                          Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR
                        }
                      />
                    </Form.Group>
                  )}

                {isVendorInActive && (
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id={
                        Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS
                      }
                      value={
                        Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS
                      }
                      label={
                        Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS_LABEL
                      }
                      onChange={handleChange}
                      checked={
                        actionType ===
                        Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS
                      }
                    />
                  </Form.Group>
                )}
                {rolePermissionForDeleteVendor === rolePermConsts.EDIT &&
                  isPrimayVendorAndHasNoSecondary() && (
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={Constants.ACTION_OPTIONS_DELETE_VENDOR}
                        value={Constants.ACTION_OPTIONS_DELETE_VENDOR}
                        label={
                          Constants.ACTION_OPTIONS_REQUEST_DELETE_VENDOR_LABEL +
                          store?.profileTypeAndConnection
                        }
                        onChange={handleChange}
                        checked={
                          actionType === Constants.ACTION_OPTIONS_DELETE_VENDOR
                        }
                      />
                    </Form.Group>
                  )}
                {vendorProfileDetails?.merchandiseType === Constants.MP &&
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id={Constants.MP_REQUEST_MORE_DATA_ID}
                      value={Constants.MP_REQUEST_MORE_DATA_ID}
                      label={
                        Constants.MP_REQUEST_MORE_DATA_LABEL
                      }
                      onChange={handleChange}
                      checked={
                        actionType === Constants.MP_REQUEST_MORE_DATA_ID
                      }
                    />
                  </Form.Group>
                }
              </div>
              <div className="vendorOnboarding_action_formArea">
                {(actionType === Constants.ACTION_OPTIONS_REQUEST_VENDOR ||
                  actionType === Constants.ACTION_OPTIONS_REQUEST_MERCHANT ||
                  actionType === Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES ||
                  actionType ===
                    Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN) && (
                  <Form.Group className="mb-0">
                    <Row>
                      <Form.Control
                        name="comments"
                        id="comments"
                        as="textarea"
                        rows="12"
                        style={{ fontSize: "14px" }}
                        placeholder={getPlaceHoder()}
                        value={comments}
                        onChange={handleChange}
                        length="12"
                        maxLength="1000"
                      />
                    </Row>
                  </Form.Group>
                )}
                {actionType === Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT && (
                  <Form.Group className="mb-0">
                    <p style={{ fontSize: "13px", fontWeight: "500" }}>
                      Are you sure you wish to return this vendor to merchant?
                    </p>
                    <Row>
                      <Form.Control
                        as="select"
                        id="noteCategory"
                        name="noteCategory"
                        value={noteCategory}
                        onChange={handleChange}
                        onBlur={handleValidate}
                        style={{
                          width: "60%",
                          border: noteError
                            ? "1px solid #d64a4a"
                            : "1px solid #ced4da",
                        }}
                      >
                        <option value="" hidden disabled>
                          {"Select category..."}
                        </option>
                        {noteCategoryOptions.map((option) => (
                          <option value={option.optionValue}>
                            {option.optionName}
                          </option>
                        ))}
                      </Form.Control>
                    </Row>
                    {noteError && (
                      <div style={{ color: "#d64a4a" }}>
                        Category is required.
                      </div>
                    )}
                    <Row>
                      <Form.Control
                        name="note"
                        id="note"
                        as="textarea"
                        rows="12"
                        placeholder={getPlaceHoder()}
                        style={{ fontSize: "14px" }}
                        value={note}
                        onChange={handleChange}
                        length="12"
                        maxLength="400"
                      />
                    </Row>
                  </Form.Group>
                )}
                {(actionType === Constants.MP_REQUEST_MORE_DATA_ID
                  && vendorProfileDetails?.merchandiseType === Constants.MP) && (
                    <Form.Group className="mb-0">
                      <Row>
                        <Form.Control
                          as="select"
                          id="dataRequestType"
                          name="dataRequestType"
                          value={dataRequestType}
                          onChange={handleChange}
                          onBlur={handleValidateDataReqType}
                          style={{
                            width: "60%",
                            border: (dataRequestTypeErr && dataRequestType === ""
                              ? "1px solid #d64a4a"
                              : "1px solid #ced4da"),
                          }}
                        >
                          <option value="" hidden disabled>
                            {"Select data request type..."}
                          </option>
                          {moreOptionsForMPIL.map((option) => (
                            <option value={option.optionValue}>
                              {option.optionName}
                            </option>
                          ))}
                        </Form.Control>
                      </Row>
                      {dataRequestTypeErr && (
                        <div style={{ color: "#d64a4a" }}>
                          Please select data request type!
                        </div>
                      )}
                      <Row>
                        <Form.Control
                          name="dataRequestTypeComment"
                          id="dataRequestTypeComment"
                          as="textarea"
                          rows="12"
                          placeholder={getPlaceHoder()}
                          style={{ fontSize: "14px" }}
                          value={dataRequestTypeComment}
                          onChange={handleChange}
                          onBlur={handleValidateDataReqType}
                          length="12"
                          maxLength="3000"
                        />
                      </Row>
                    </Form.Group>
                  )}
                {actionType === Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT && (
                  <Form.Group className="mb-0">
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        marginTop: 100,
                      }}
                    >
                      Are you sure you wish to submit this vendor record to
                      Merch Ops for Integration and Order Testing ?
                    </p>
                  </Form.Group>
                )}
                {actionType ===
                  Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR && (
                  <Form.Group className="mb-0">
                    <>
                      <p style={{ fontSize: "13px", fontWeight: "500" }}>
                        Are you sure you wish to move this vendor to "Inactive"
                        status?
                      </p>
                      <Row>
                        <Form.Control
                          as="select"
                          id="inactiveCategory"
                          name="inactiveCategory"
                          value={inactiveCategory}
                          onChange={handleChange}
                          onBlur={handleValidate}
                          style={{
                            width: "60%",
                            border: noteError
                              ? "1px solid #d64a4a"
                              : "1px solid #ced4da",
                          }}
                        >
                          <option value="" hidden disabled>
                            {'Select "Inactive" category...'}
                          </option>
                          {inactiveStatusHoldOptions().map((option) => (
                            <option value={option.optionValue}>
                              {option.optionName}
                            </option>
                          ))}
                        </Form.Control>
                      </Row>
                    </>
                    <Row>
                      <Form.Control
                        name="comments"
                        id="comments"
                        as="textarea"
                        rows="12"
                        style={{ fontSize: "14px" }}
                        placeholder={getPlaceHoder()}
                        value={comments}
                        onChange={handleChange}
                        length="12"
                        maxLength="400"
                      />
                    </Row>
                  </Form.Group>
                )}
                {actionType ===
                  Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS && (
                  <Form.Group className="mb-0">
                    <p style={{ fontSize: "13px", fontWeight: "500" }}>
                      {
                        Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS_TEXTBOX_LABEL
                      }
                    </p>
                    <Row>
                      <Form.Control
                        name="comments"
                        id="comments"
                        as="textarea"
                        rows="12"
                        style={{ fontSize: "14px" }}
                        placeholder={getPlaceHoder()}
                        value={comments}
                        onChange={handleChange}
                        maxLength="400"
                      />
                    </Row>
                  </Form.Group>
                )}
                {actionType === Constants.ACTION_OPTIONS_DELETE_VENDOR && (
                  <Form.Group className="mb-0">
                    <p
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        marginBottom: "0px",
                      }}
                    >
                      {Constants.ACTION_OPTIONS_DELETE_VENDOR_TEXTBOX_LABEL}
                    </p>
                    <Row style={{ gap: "10px", marginLeft: "-10px" }}>
                      <Form.Check
                        type={"radio"}
                        name={"deleteOption"}
                        label={"Yes"}
                        onChange={handleChange}
                        value={"yes"}
                      />
                      <Form.Check
                        type={"radio"}
                        name={"deleteOption"}
                        label={"No"}
                        onChange={handleChange}
                        value={"no"}
                      />
                    </Row>
                    {vendorDeleteOption === "yes" && (
                      <Row>
                        <Form.Control
                          name="comments"
                          id="deleteComments"
                          as="textarea"
                          rows="12"
                          placeholder={getPlaceHoder()}
                          style={{ fontSize: "14px" }}
                          value={comments}
                          onChange={handleChange}
                          length="12"
                          maxLength="1000"
                        />
                      </Row>
                    )}
                  </Form.Group>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="commonActionsModalFooter px-3">
          <Button
            className="button-primary-md mx-4"
            disabled={
              actionType === "" ||
              ((actionType === Constants.ACTION_OPTIONS_REQUEST_VENDOR ||
                actionType === Constants.ACTION_OPTIONS_REQUEST_MERCHANT ||
                actionType === Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES ||
                actionType ===
                Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN) &&
                (!comments || actionBtnDisabled)) ||
              (actionType === Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT &&
                (noteCategory === "" || noteError || actionBtnDisabled)) ||
              (actionType === Constants.MP_REQUEST_MORE_DATA_ID &&
                (dataRequestTypeComment === ""  || dataRequestType === ""  || actionBtnDisabled)) ||
              (actionType === Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR &&
                (inactiveCategory === "" || !comments || actionBtnDisabled)) ||
              (actionType ===
                Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS &&
                (!comments || actionBtnDisabled)) ||
              (actionType === Constants.ACTION_OPTIONS_DELETE_VENDOR &&
                (!comments || actionBtnDisabled))
            }
            onClick={onClickHandler}
          >
            {Constants.ACTION_SUBMIT_BUTTON}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CommonActionsModal;
